import GlobalContext from '../bootstrap';
import Discardable from '../property/discard';
import initPropertySliders from '../property/sliders';
import initCharacterLimit from '../characterlimit';

class DirectoryDetailsPage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        new Discardable();

        initPropertySliders();

        initCharacterLimit();
    }
}

if ( !window.directoryDetailsPage ) {
    window.directoryDetailsPage = new DirectoryDetailsPage();
}
